import React, { useCallback, useMemo, useRef, useState } from 'react';
import moment from 'moment';
import ReactToPrint from 'react-to-print';
import { useDispatch, useSelector } from 'react-redux';
import GeniusReportsDate from '../utility/component/reportDate';
import GeniusTableForReports from '../utility/component/geniusComponents/geniusTableforReports';
import ItemMasterHelp from '../master/iteemMasterHelp';
import DepartmentMasterHelp from '../master/departmentHelp';
import ModListStationMaster from '../utility/component/modals/modListStationMaster';
import AlertModalTwoButton from '../utility/component/modals/alertWithTwoButton';
import {
  setAlertWithTitle,
  setDepartmentMasterHelpStatus,
  setItemMasterHelpStatus,
  setListStationMasterModalStatus,
  setSpinnerLoading,
} from '../utility/Redux/modal';
import {
  selectPrefix,
  selectStationId,
  selectStationName,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setStationID,
  setStationName,
  setreportsFromDate,
  setreportsTodate,
} from '../utility/Redux/profile';
import { selectToken } from '../utility/Redux/security';
import { CallAPIPromise } from '../routeBilling/menu/dashboard/biiling/modal/comman';
import { FormatNumber2 } from '../utility/component/tools';
import ReportDataTable from '../utility/component/datagrid/ReportDataTable';

export const STAGE_FLOW2 = [
  {
    id: 'STOCK_IN',
    title: 'Stage 1',
    label: 'Stock In',
    direction: 'STOCK_IN',
    api: '/api/saveFlowTransaction/saveFlowTransaction',
    color: '#1d4ed8',
    bg: '#eff6ff',
  },
  {
    id: 'ISSUE_TO_DEPARTMENT',
    title: 'Stage 2',
    label: 'Issue to Department',
    direction: 'ISSUED_TO_DEP',
    api: '/api/saveIssueDepartment/saveIssueDepartment',
    color: '#15803d',
    bg: '#ecfdf3',
  },
  {
    id: 'RECEIVE_FROM_DEPARTMENT',
    title: 'Stage 3',
    label: 'Receive from Department',
    direction: 'RECEIVED_FROM_DEP',
    api: '/api/receiveFromDepartment/receiveFromDepartment',
    color: '#a16207',
    bg: '#fefce8',
  },
  {
    id: 'ISSUE_TO_STORE',
    title: 'Stage 4',
    label: 'Issue to Store',
    direction: 'ISSUED_TO_STORE',
    api: '/api/issueToStore/issueToStore',
    color: '#b91c1c',
    bg: '#fef2f2',
  },
  {
    id: 'ISSUE_TO_SID',
    title: 'Stage 5',
    label: 'Issue to SID (Station)',
    direction: 'ISSUED_TO_SID',
    api: '/api/issueToRoute/issueToRoute',
    color: '#b91c1c',
    bg: '#fef2f2',
  },
  {
    id: 'VERIFY_TRUCK',
    title: 'Stage 6',
    label: 'Verify Truck',
    direction: 'VERIFIED_TRUCK',
    api: '/api/verifyTruck/verifyTruck',
    color: '#111827',
    bg: '#f9fafb',
  },
];

export const STAGE_FLOW = [
  {
    id: 'STOCK_IN',
    title: 'Stage 1',
    label: 'Stock In',
    direction: 'STOCK_IN',
  },
  {
    id: 'ISSUE_TO_DEPARTMENT',
    title: 'Stage 2',
    label: 'Issue to Department',
    direction: 'ISSUED_TO_DEP',
  },
  {
    id: 'RECEIVE_FROM_DEPARTMENT',
    title: 'Stage 3',
    label: 'Receive from Department',
    direction: 'RECEIVED_FROM_DEP',
  },
  {
    id: 'ISSUE_TO_STORE',
    title: 'Stage 4',
    label: 'Issue to Store',
    direction: 'ISSUED_TO_STORE',
  },
  {
    id: 'ISSUE_TO_SID',
    title: 'Stage 5',
    label: 'Issue to SID (Station)',
    direction: 'ISSUED_TO_SID',
  },
  {
    id: 'VERIFY_TRUCK',
    title: 'Stage 6',
    label: 'Verify Truck',
    direction: 'VERIFIED_TRUCK',
  },
];

const textColumn = (field, headerName, width = 150) => ({
  field,
  type: 'string',
  width,
  accessor:field,

  headerAlign: 'center',
  align: 'left',
  renderHeader: () => (
    <div className="whitespace-normal leading-4 text-center text-xs">
      {headerName}
    </div>
  ),
});

const numberColumn = (field, headerName, width = 105) => ({
  field,
  type: 'number',
  width,
  accessor:field,

  headerAlign: 'center',
  align: 'right',
  valueFormatter: (params) => {
    if (params.value === null ||params.value === 0|| params.value === undefined || params.value === '') {
      return '';
    }
    return FormatNumber2(params.value);
  },
  renderHeader: () => (
    <div className="whitespace-normal leading-4 text-center text-xs">
      {headerName}
    </div>
  ),
});

const dateColumn = (field, headerName, width = 90, format = 'DD-MM-YYYY') => ({
  field,
  accessor:field,
  type: 'date',
  width,
  headerAlign: 'center',
  align: 'center',
  valueFormatter: (params) => {
    if (!params.value) {
      return '';
    }
    return moment(params.value).format(format);
  },
  renderHeader: () => (
    <div className="whitespace-normal leading-4 text-center text-xs">
      {headerName}
    </div>
  ),
});

const buildColumns = (width) => [
  dateColumn('date', 'Date'),
  textColumn('icode', 'Item Code', 60),
  textColumn('itemname', 'Item Name', width < 1280 ? 140 : 180),
  textColumn('stage_name', 'Stage', 175),
  textColumn('epc', 'EPC', 200),
  textColumn('dep_name', 'Department', 150),
  textColumn('sid', 'SID', 60),
  textColumn('truck_no', 'Truck No.', 80),
  numberColumn('empty_box', 'Empty Box',90),
  numberColumn('dep_issued_qnty', 'Department Issue Qnty', 90),
  numberColumn('filled_box', 'Filled Box',90),
  numberColumn('issue_to_store_qnty', 'Issue Store Qnty', 90),
  numberColumn('route_issue_qnty', 'Route Issue Qnty', 90),
  numberColumn('route_return_qnty', 'Route Return Qnty', 90),
  numberColumn('truck_qnty', 'Truck Qnty',90),
  numberColumn('truck_mismatched_qnty', 'Truck Mismatch Qnty', 90),
  numberColumn('damage_qnty', 'Damage Qnty', 90),
  dateColumn('created_at', 'Created At', 150, 'DD-MM-YYYY HH:mm'),
  dateColumn('updated_at', 'Updated At', 150, 'DD-MM-YYYY HH:mm'),
];

const deleteColumn = (onDelete) => ({
  field: 'delete',
  headerName: 'Delete',
  width: 70,
  sortable: false,
  filterable: false,
  disableColumnMenu: true,
  headerAlign: 'center',
  align: 'center',
  renderHeader: () => <div>Delete</div>,
  renderCell: (params) => (
    <button
      type="button"
      title="Delete"
      onClick={() => onDelete(params.row)}
      className="text-red-500"
    >
      <i className="bi bi-x-square-fill text-[18px]"></i>
    </button>
  ),
});

const STAGE_QTY_FIELD = {
  STOCK_IN: 'empty_box',
  ISSUED_TO_DEP: 'dep_issued_qnty',
  RECEIVED_FROM_DEP: 'filled_box',
  ISSUED_TO_STORE: 'issue_to_store_qnty',
  ISSUED_TO_SID: 'route_issue_qnty',
  VERIFIED_TRUCK: 'truck_qnty',
};

const normalizeFilterText = (value) => String(value || '').trim().toUpperCase();

const toNumber = (value) => {
  const number = Number(value);
  return Number.isFinite(number) ? number : 0;
};

const getStageMeta = (stageName) => {
  const normalizedStageName = normalizeFilterText(stageName);

  return (
    STAGE_FLOW2.find(
      (stage) =>
        normalizeFilterText(stage.direction) === normalizedStageName ||
        normalizeFilterText(stage.label) === normalizedStageName
    ) || null
  );
};

const formatCount = (value) => {
  const number = toNumber(value);
  return number ? FormatNumber2(number) : '';
};

const getReadableItemStatus = (item) => {
  if (item.mismatch) {
    return {
      label: `${formatCount(item.mismatch)} missing in truck`,
      tone: 'danger',
    };
  }

  if (item.pendingTruck) {
    return {
      label: `${formatCount(item.pendingTruck)} pending for truck verify`,
      tone: 'warning',
    };
  }

  if (item.damage) {
    return {
      label: `${formatCount(item.damage)} damaged`,
      tone: 'danger',
    };
  }

  const lastStage = [...STAGE_FLOW2]
    .reverse()
    .find((stage) => item.stages[stage.direction]?.qty);

  return {
    label: lastStage ? `Currently at ${lastStage.label}` : 'No movement found',
    tone: lastStage?.direction === 'VERIFIED_TRUCK' ? 'success' : 'neutral',
  };
};

const statusStyle = {
  danger: {
    backgroundColor: '#fff1f1',
    borderColor: '#fecaca',
    color: '#991b1b',
  },
  warning: {
    backgroundColor: '#fffbea',
    borderColor: '#fde68a',
    color: '#92400e',
  },
  success: {
    backgroundColor: '#ecfdf3',
    borderColor: '#bbf7d0',
    color: '#166534',
  },
  neutral: {
    backgroundColor: '#f5f5f5',
    borderColor: '#e5e5e5',
    color: '#444',
  },
};

const stageRowClassName = {
  STOCK_IN: '!bg-blue-50 text-blue-700',
  ISSUED_TO_DEP: '!bg-emerald-50 text-emerald-700',
  RECEIVED_FROM_DEP: '!bg-yellow-50 text-yellow-700',
  ISSUED_TO_STORE: '!bg-red-50 text-red-700',
  ISSUED_TO_SID: '!bg-red-50 text-red-700',
  VERIFIED_TRUCK: '!bg-slate-50 text-slate-900',
};

const buildFlowInsights = (rows) => {
  const stageTotals = STAGE_FLOW2.map((stage) => ({
    ...stage,
    qty: 0,
    rows: 0,
    mismatch: 0,
    damage: 0,
  }));
  const stageMap = Object.fromEntries(stageTotals.map((stage) => [stage.direction, stage]));
  const itemMap = new Map();

  rows.forEach((row) => {
    const stage = getStageMeta(row.stage_name);
    const direction = stage?.direction || row.stage_name || 'UNKNOWN';
    const qtyField = STAGE_QTY_FIELD[direction];
    const stageQty = qtyField ? toNumber(row[qtyField]) : 0;
    const mismatchQty = toNumber(row.truck_mismatched_qnty);
    const damageQty = toNumber(row.damage_qnty);
    const routeIssueQty = toNumber(row.route_issue_qnty);
    const truckQty = toNumber(row.truck_qnty);
    const pendingTruckQty = Math.max(routeIssueQty - truckQty - mismatchQty, 0);
    const itemCodeValue = String(row.icode || row.ICODE || '').trim();
    const itemNameValue = row.itemname || row.ITEMNAME || row.INAME || '';
    const itemKey = `${itemCodeValue || 'NA'}|${itemNameValue || 'Unknown Item'}`;

    if (stageMap[direction]) {
      stageMap[direction].qty += stageQty;
      stageMap[direction].rows += 1;
      stageMap[direction].mismatch += mismatchQty;
      stageMap[direction].damage += damageQty;
    }

    if (!itemMap.has(itemKey)) {
      itemMap.set(itemKey, {
        key: itemKey,
        icode: itemCodeValue,
        itemname: itemNameValue || 'Unknown Item',
        scanRows: 0,
        epcs: new Set(),
        stages: Object.fromEntries(
          STAGE_FLOW2.map((itemStage) => [
            itemStage.direction,
            {
              qty: 0,
              epcs: 0,
            },
          ])
        ),
        mismatch: 0,
        damage: 0,
        routeIssue: 0,
        truck: 0,
        pendingTruck: 0,
      });
    }

    const item = itemMap.get(itemKey);
    item.scanRows += 1;
    if (row.epc || row.EPC) {
      item.epcs.add(row.epc || row.EPC);
    }
    item.mismatch += mismatchQty;
    item.damage += damageQty;
    item.routeIssue += routeIssueQty;
    item.truck += truckQty;
    item.pendingTruck += pendingTruckQty;

    if (item.stages[direction]) {
      item.stages[direction].qty += stageQty;
      item.stages[direction].epcs += 1;
    }
  });

  const items = Array.from(itemMap.values()).map((item) => ({
    ...item,
    epcCount: item.epcs.size || item.scanRows,
  })).sort((a, b) => {
    const issueDiff =
      b.mismatch + b.damage + b.pendingTruck - (a.mismatch + a.damage + a.pendingTruck);

    if (issueDiff) {
      return issueDiff;
    }

    return a.itemname.localeCompare(b.itemname);
  });

  return {
    totalRows: rows.length,
    totalMismatch: items.reduce((sum, item) => sum + item.mismatch, 0),
    totalDamage: items.reduce((sum, item) => sum + item.damage, 0),
    totalPendingTruck: items.reduce((sum, item) => sum + item.pendingTruck, 0),
    stageTotals,
    items,
  };
};

const emptyTwoButtonAlert = {
  title: '',
  msg: '',
  status: false,
  setStatus: '',
  button1: '',
  button1Click: '',
  button2: '',
  button2Click: '',
};

const FilterValue = ({ title, value, details, onSearch, onClear }) => (
  <div className="flex items-center px-3 py-2 border-r border-[#b5b3b3]">
    <button className="flex items-center" onClick={onSearch}>
      <i className="bi bi-search" style={{ color: '#f44336', fontSize: 15 }}></i>
      <span className="text-[#5c5b5b] font-semibold pl-2 whitespace-nowrap text-xs">
        {title}
      </span>
    </button>
    <div
      style={{ border: '1px dotted #a6a2a2', borderRadius: 3 }}
      className="flex items-center text-[#a6a2a2] ml-2 min-h-[28px]"
    >
      <input
        readOnly
        value={value || 'All'}
        className="outline-0 bg-transparent text-xs px-2 w-16"
      />
      {details ? (
        <div className="border-l border-dotted border-[#a6a2a2] px-2 whitespace-nowrap text-xs text-[#5c5b5b]">
          {details}
        </div>
      ) : null}
      {value ? (
        <button onClick={onClear} className="px-2">
          <i className="bi text-red-500 bi-backspace-fill font-semibold"></i>
        </button>
      ) : null}
    </div>
  </div>
);

const FlowInsightView = ({ insights }) => {
  const problemItems = insights.items.filter(
    (item) => item.mismatch || item.damage || item.pendingTruck
  );

  return (
    <div className="w-full">
      <div className="grid grid-cols-2 xl:grid-cols-4 gap-2">
        <div className="border border-[#d4d4d4] bg-white px-3 py-2">
          <div className="text-[11px] uppercase text-[#777]">Transactions</div>
          <div className="text-lg font-semibold text-[#333]">{formatCount(insights.totalRows) || 0}</div>
        </div>
        <div className="border border-[#d4d4d4] bg-white px-3 py-2">
          <div className="text-[11px] uppercase text-[#777]">Items</div>
          <div className="text-lg font-semibold text-[#333]">{formatCount(insights.items.length) || 0}</div>
        </div>
        <div className="border border-[#fecaca] bg-[#fff7f7] px-3 py-2">
          <div className="text-[11px] uppercase text-[#991b1b]">Missing / Mismatch</div>
          <div className="text-lg font-semibold text-[#991b1b]">
            {formatCount(insights.totalMismatch) || 0}
          </div>
        </div>
        <div className="border border-[#fde68a] bg-[#fffbea] px-3 py-2">
          <div className="text-[11px] uppercase text-[#92400e]">Pending Truck</div>
          <div className="text-lg font-semibold text-[#92400e]">
            {formatCount(insights.totalPendingTruck) || 0}
          </div>
        </div>
      </div>

      <div className="mt-3 grid grid-cols-1 xl:grid-cols-6 gap-2">
        {insights.stageTotals.map((stage) => (
          <div
            key={stage.direction}
            className="border px-3 py-2 min-h-[78px]"
            style={{ borderColor: stage.color, backgroundColor: stage.bg }}
          >
            <div className="text-[11px] font-semibold" style={{ color: stage.color }}>
              {stage.title}
            </div>
            <div className="text-xs text-[#333]">{stage.label}</div>
            <div className="mt-1 text-lg font-bold" style={{ color: stage.color }}>
              {formatCount(stage.qty) || 0}
            </div>
            <div className="text-[11px] text-[#555]">{stage.rows} row(s)</div>
          </div>
        ))}
      </div>

      {problemItems.length ? (
        <div className="mt-3 border border-[#fecaca] bg-[#fff7f7] px-3 py-2">
          <div className="font-semibold text-[#991b1b]">Needs attention</div>
          <div className="mt-2 grid grid-cols-1 xl:grid-cols-3 gap-2">
            {problemItems.slice(0, 6).map((item) => (
              <div key={item.key} className="bg-white border border-[#fecaca] px-3 py-2">
                <div className="font-semibold text-[#333]">
                  {item.icode ? `${item.icode} - ` : ''}
                  {item.itemname}
                </div>
                <div className="mt-1 text-xs text-[#991b1b]">
                  {item.mismatch ? `Missing/Mismatch: ${formatCount(item.mismatch)} ` : ''}
                  {item.pendingTruck ? `Pending Truck: ${formatCount(item.pendingTruck)} ` : ''}
                  {item.damage ? `Damage: ${formatCount(item.damage)}` : ''}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : null}

      <div className="mt-3 overflow-auto border border-[#d4d4d4]">
        <table className="w-full min-w-[1180px] text-xs">
          <thead className="bg-[#353232] text-white">
            <tr>
              <th className="text-left px-3 py-2 w-[230px]">Item</th>
              <th className="text-left px-3 py-2 w-[190px]">Read This</th>
              <th className="text-right px-2 py-2">Tags</th>
              <th className="text-right px-2 py-2">Scan Rows</th>
              {STAGE_FLOW2.map((stage) => (
                <th key={stage.direction} className="text-right px-2 py-2">
                  {stage.label}
                </th>
              ))}
              <th className="text-right px-2 py-2 text-[#fecaca]">Missing</th>
              <th className="text-right px-2 py-2 text-[#fde68a]">Pending</th>
            </tr>
          </thead>
          <tbody>
            {insights.items.map((item) => {
              const readableStatus = getReadableItemStatus(item);

              return (
                <tr key={item.key} className="border-t border-[#e5e5e5]">
                  <td className="px-3 py-2 font-semibold text-[#333]">
                    {item.icode ? `${item.icode} - ` : ''}
                    {item.itemname}
                  </td>
                  <td className="px-3 py-2">
                    <span
                      className="inline-block px-2 py-1 font-semibold"
                      style={{
                        border: `1px solid ${statusStyle[readableStatus.tone].borderColor}`,
                        backgroundColor: statusStyle[readableStatus.tone].backgroundColor,
                        color: statusStyle[readableStatus.tone].color,
                      }}
                    >
                      {readableStatus.label}
                    </span>
                  </td>
                  <td className="px-2 py-2 text-right">{formatCount(item.epcCount) || 0}</td>
                  <td className="px-2 py-2 text-right text-[#777]">{formatCount(item.scanRows) || 0}</td>
                  {STAGE_FLOW2.map((stage) => {
                    const stageItem = item.stages[stage.direction];
                    const active = Boolean(stageItem?.qty || stageItem?.epcs);

                    return (
                      <td key={stage.direction} className="px-2 py-2 text-right">
                        <span
                          className="inline-block min-w-[34px] px-2 py-1"
                          style={{
                            backgroundColor: active ? stage.bg : '#f5f5f5',
                            color: active ? stage.color : '#999',
                            border: `1px solid ${active ? stage.color : '#e0e0e0'}`,
                          }}
                        >
                          {formatCount(stageItem?.qty) || 0}
                        </span>
                      </td>
                    );
                  })}
                  <td className="px-2 py-2 text-right font-semibold text-[#991b1b]">
                    {formatCount(item.mismatch) || ''}
                  </td>
                  <td className="px-2 py-2 text-right font-semibold text-[#92400e]">
                    {formatCount(item.pendingTruck) || ''}
                  </td>
                </tr>
              );
            })}
            {!insights.items.length ? (
              <tr>
                <td className="px-3 py-8 text-center text-[#777]" colSpan={STAGE_FLOW2.length + 6}>
                  No records found
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export const FlowTransactionReportBase = ({
  apiPath,
  reportTitle,
}) => {
  const dispatch = useDispatch();
  const printRef = useRef();
  const prefix = useSelector(selectPrefix);
  const token = useSelector(selectToken);
  const width = useSelector(selectWidth);
  const fromDate = useSelector(selectreportFromDate);
  const toDate = useSelector(selectreportToDate);
  const stationId = useSelector(selectStationId);
  const stationName = useSelector(selectStationName);
  const [fromDateFocus, setFromDateFocus] = useState(false);
  const [toDateFocus, setToDateFocus] = useState(false);
  const [list, setList] = useState([]);
  const [itemCode, setItemCode] = useState('');
  const [itemName, setItemName] = useState('');
  const [depName, setDepName] = useState('');
  const [epc, setEpc] = useState('');
  const [stageName, setStageName] = useState('');
  const [viewMode, setViewMode] = useState('flow');
  const [alertTwoButtonModal, setAlertTwoButtonModal] = useState(emptyTwoButtonAlert);

  const columns = useMemo(() => buildColumns(width), [width]);
  const selectedStage = STAGE_FLOW.find((stage) => stage.direction === stageName);
  const isSummaryReport = reportTitle === 'Flow Transaction Summary';
  const filteredList = useMemo(() => {
    const selectedIcode = String(itemCode || '').trim();
    const selectedSid = String(stationId || '').trim();
    const selectedStageName = normalizeFilterText(stageName);
    const selectedEpc = normalizeFilterText(epc);
    const selectedDepName = normalizeFilterText(depName);

    return list.filter((row) => {
      const rowIcode = String(row.icode || row.ICODE || '').trim();
      const rowSid = String(row.sid || row.SID || '').trim();
      const rowStageName = normalizeFilterText(row.stage_name || row.STAGE_NAME);
      const rowEpc = normalizeFilterText(row.epc || row.EPC);
      const rowDepName = normalizeFilterText(
        row.dep_name || row.DEP_NAME || row.DEPARTMENT_NAME
      );

      if (selectedIcode && rowIcode !== selectedIcode) {
        return false;
      }
      if (selectedSid && rowSid !== selectedSid) {
        return false;
      }
      if (selectedStageName && rowStageName !== selectedStageName) {
        return false;
      }
      if (selectedEpc && !rowEpc.includes(selectedEpc)) {
        return false;
      }
      if (selectedDepName && rowDepName !== selectedDepName) {
        return false;
      }

      return true;
    });
  }, [depName, epc, itemCode, list, stageName, stationId]);
  const flowInsights = useMemo(() => buildFlowInsights(filteredList), [filteredList]);

  const deleteFlowTransaction = useCallback(
    (row) => {
      const selectedEpc = String(row?.epc || row?.EPC || '').trim();

      if (!selectedEpc) {
        dispatch(
          setAlertWithTitle({
            title: 'Alert',
            msg: 'EPC not found for this row.',
          })
        );
        return;
      }

      dispatch(setSpinnerLoading('Deleting'));
      CallAPIPromise(
        '/api/deleteFlowTransection/deleteFlowTransection',
        {
          table_prefix: prefix,
          epc: selectedEpc,
        },
        token
      )
        .then((res) => {
          if (!res.data.error) {
            setList((currentList) =>
              currentList.filter(
                (item) => String(item.epc || item.EPC || '').trim() !== selectedEpc
              )
            );
            dispatch(
              setAlertWithTitle({
                title: 'Deleted',
                msg: 'Flow transaction deleted successfully.',
              })
            );
          } else {
            dispatch(
              setAlertWithTitle({
                title: 'Error',
                msg: res.data.message || 'Something Went Wrong!',
              })
            );
          }
        })
        .catch((error) => {
          console.log(error);
          dispatch(
            setAlertWithTitle({
              title: 'Error',
              msg: 'Something Went Wrong!',
            })
          );
        })
        .finally(() => {
          dispatch(setSpinnerLoading(false));
        });
    },
    [dispatch, prefix, token]
  );

  const handleDelete = useCallback(
    (row) => {
      const selectedEpc = String(row?.epc || row?.EPC || '').trim();

      if (!selectedEpc) {
        dispatch(
          setAlertWithTitle({
            title: 'Alert',
            msg: 'EPC not found for this row.',
          })
        );
        return;
      }

      setAlertTwoButtonModal({
        ...emptyTwoButtonAlert,
        status: true,
        title: 'Delete Flow Transaction',
        msg: `Are you sure you want to delete EPC ${selectedEpc}?`,
        button1: 'Yes',
        button2: 'No',
        button1Click: () => {
          setAlertTwoButtonModal(emptyTwoButtonAlert);
          deleteFlowTransaction(row);
        },
        button2Click: () => setAlertTwoButtonModal(emptyTwoButtonAlert),
      });
    },
    [deleteFlowTransaction, dispatch]
  );

  const gridColumns = useMemo(
    () => {
      if (isSummaryReport) {
      return  [...columns, deleteColumn(handleDelete)]
        
      } else {
      return  [...columns]
        
      }
    },
    [columns, handleDelete, isSummaryReport]
  );

  const getReport = () => {
    const selectedEpc = String(epc || '').trim();
    dispatch(setSpinnerLoading('Loading'));
    CallAPIPromise(
      apiPath,
      {
        table_prefix: prefix,
        from_date: moment(fromDate).format('YYYY-MM-DD'),
        to_date: moment(toDate).format('YYYY-MM-DD'),
        icode: itemCode || '',
        stage_name: stageName || '',
        epc: selectedEpc || '',
        dep_name: depName || '',
        sid: stationId || '',
      },
      token
    )
      .then((res) => {
        if (!res.data.error) {
          const response = Array.isArray(res.data.response) ? res.data.response : [];
          setList(response.map((row, index) => ({ ...row, id: row.id || index + 1 ,sid:String(row.sid),icode:String(row.icode)})));
        } else {
          dispatch(
            setAlertWithTitle({
              title: 'Error',
              msg: 'Something Went Wrong!',
            })
          );
        }
      })
      .catch((error) => {
        console.log(error);
        dispatch(
          setAlertWithTitle({
            title: 'Error',
            msg: 'Something Went Wrong!',
          })
        );
      })
      .finally(() => {
        dispatch(setSpinnerLoading(false));
      });
  };

  const reset = () => {
    setItemCode('');
    setItemName('');
    setDepName('');
    setEpc('');
    setStageName('');
    dispatch(setStationID(''));
    dispatch(setStationName(''));
    setList([]);
  };

  return (
    <div className="h-full w-full p-2 text-sm">

    <style>
      {`
        @media print {
          @page {
            size: landscape;
            margin: 10mm;
          }

          body {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }
        }
      `}
    </style>

      <div className="border border-[#b5b3b3] rounded-sm overflow-hidden">
        <div className="flex flex-wrap items-center">
          <div className="flex items-center px-3 py-2 border-r border-[#b5b3b3]">
            <div className="pr-2 text-[#4B4545]">From</div>
            <GeniusReportsDate
              date={fromDate}
              onChange={(date) => {
                dispatch(setreportsFromDate(moment(date).format('YYYY-MM-DD')));
                setFromDateFocus(false);
              }}
              dateFocus={fromDateFocus}
              SetDateFocus={setFromDateFocus}
            />
            <div className="px-3 text-[#4B4545]">To</div>
            <GeniusReportsDate
              date={toDate}
              onChange={(date) => {
                dispatch(setreportsTodate(moment(date).format('YYYY-MM-DD')));
                setToDateFocus(false);
              }}
              dateFocus={toDateFocus}
              SetDateFocus={setToDateFocus}
            />
          </div>

          <FilterValue
            title="Item Code"
            value={itemCode}
            details={itemName}
            onSearch={() => dispatch(setItemMasterHelpStatus(true))}
            onClear={() => {
              setItemCode('');
              setItemName('');
            }}
          />

          <FilterValue
            title="Department"
            value={depName}
            onSearch={() => dispatch(setDepartmentMasterHelpStatus(true))}
            onClear={() => setDepName('')}
          />

          <FilterValue
            title="Station ID"
            value={stationId}
            details={stationName}
            onSearch={() => dispatch(setListStationMasterModalStatus(true))}
            onClear={() => {
              dispatch(setStationID(''));
              dispatch(setStationName(''));
            }}
          />

          <div className="flex items-center px-3 py-2 border-r border-[#b5b3b3]">
            <span className="text-[#5c5b5b] font-semibold pr-2 whitespace-nowrap text-xs">
              Stage
            </span>
            <select
              value={stageName}
              onChange={(event) => setStageName(event.target.value)}
              className="border border-[#b5b3b3] rounded-sm outline-0 bg-white px-2 py-1 text-xs min-w-[180px]"
            >
              <option value="">All</option>
              {STAGE_FLOW.map((stage) => (
                <option key={stage.id} value={stage.direction}>
                  {stage.title} - {stage.label}
                </option>
              ))}
            </select>
          </div>

          <div className="flex items-center px-3 py-2 border-r border-[#b5b3b3]">
            <span className="text-[#5c5b5b] font-semibold pr-2 whitespace-nowrap text-xs">
              EPC
            </span>
            <input
              value={epc}
              onChange={(event) => setEpc(event.target.value.trimStart())}
              className="border border-[#b5b3b3] rounded-sm outline-0 px-2 py-1 text-xs w-44"
              placeholder="All"
            />
          </div>

          <div className="flex items-center px-3 py-2">
            <button
              onClick={getReport}
              className="rounded-sm"
              style={{
                backgroundColor: '#c1c1c1',
                padding: '4px 30px',
                color: 'black',
              }}
            >
              Ok
            </button>
            {filteredList[0] ? (
              <ReactToPrint
                trigger={() => (
                  <button
                    style={{
                      borderRadius: 7,
                      padding: '4px 30px',
                      backgroundColor: '#bad4f9',
                      color: 'black',
                      marginLeft: 7,
                    }}
                  >
                    Print
                  </button>
                )}
                content={() => printRef.current}
              />
            ) : null}
            <button onClick={reset} className="ml-3">
              <i className="bi bi-backspace-fill" style={{ color: '#f2666f', fontSize: 18 }}></i>
            </button>
          </div>
        </div>
      </div>

      <div className="mt-2 text-xs text-[#5c5b5b] min-h-[22px]">
        {selectedStage ? `${selectedStage.title}: ${selectedStage.label}` : 'All stages'}
        {depName ? ` | Department: ${depName}` : ''}
        {itemCode ? ` | Item: ${itemCode}${itemName ? ` - ${itemName}` : ''}` : ''}
        {stationId ? ` | Station: ${stationId}${stationName ? ` - ${stationName}` : ''}` : ''}
        {epc ? ` | EPC: ${epc.trim()}` : ''}
      </div>

      {isSummaryReport ? (
        <div className="mt-2 flex items-center justify-between gap-2">
          <div className="text-xs text-[#5c5b5b]">
            {flowInsights.items.length} item(s), {flowInsights.totalMismatch} missing/mismatch, {flowInsights.totalPendingTruck} pending truck
          </div>
          <div className="flex border border-[#b5b3b3]">
            <button
              type="button"
              onClick={() => setViewMode('flow')}
              className={`px-3 py-1 text-xs ${
                viewMode === 'flow' ? 'bg-[#353232] text-white' : 'bg-white text-[#353232]'
              }`}
            >
              Flow View
            </button>
            <button
              type="button"
              onClick={() => setViewMode('grid')}
              className={`px-3 py-1 text-xs border-l border-[#b5b3b3] ${
                viewMode === 'grid' ? 'bg-[#353232] text-white' : 'bg-white text-[#353232]'
              }`}
            >
              Detail Grid
            </button>
          </div>
        </div>
      ) : null}

      <div
        style={{ height: 'calc(100% - 155px)' }}
        className="mt-2 w-full overflow-auto"
      >
        {isSummaryReport && viewMode === 'flow' ? (
          <FlowInsightView insights={flowInsights} />
        ) : (
          <ReportDataTable
            columns={gridColumns}
            rows={filteredList}
            getRowKey={(row, index) => row.id || index}
            getRowClassName={(row) => {
              const stage = STAGE_FLOW2.find(
                (s) => (s.label === row.stage_name|| s.direction===row.stage_name)
              );
            
              if (!stage) return '';

              return stageRowClassName[stage.direction] || '';
            }}
            emptyTitle="No records found"
            emptyDescription="Run the report to view flow transactions."
            maxHeight="100%"
          />
        )}
      </div>

      <div className="hidden">
        <div ref={printRef}>
          <GeniusTableForReports
            date={moment(fromDate).format('YYYY-MM-DD')}
            date1={moment(toDate).format('YYYY-MM-DD')}
            stationId={stationId}
            columns={columns}
            data={filteredList}
            title={reportTitle}
            customeHeader={
              <div className="ml-3">
                {itemCode ? ` [ Item : ${itemCode} ]` : ''}
                {depName ? ` [ Department : ${depName} ]` : ''}
                {selectedStage ? ` [ Stage : ${selectedStage.label} ]` : ''}
                {epc ? ` [ EPC : ${epc.trim()} ]` : ''}
              </div>
            }
          />
        </div>
      </div>

      <ItemMasterHelp
        onRowClick={(params) => {
          setItemCode(params.row.ICODE);
          setItemName(params.row.ITEMNAME || params.row.INAME || '');
          dispatch(setItemMasterHelpStatus(false));
        }}
      />
      <DepartmentMasterHelp setDeptName={setDepName} />
      <ModListStationMaster
        onRowClick={(params) => {
          dispatch(setStationID(params.row.CODE));
          dispatch(setStationName(params.row.STATION_NAME));
          dispatch(setListStationMasterModalStatus(false));
        }}
      />
      <AlertModalTwoButton
        details={alertTwoButtonModal}
        setAlertTwoButtonModal={setAlertTwoButtonModal}
      />
    </div>
  );
};

const FlowTransactionReportSum = () => (
  <FlowTransactionReportBase
    apiPath="/api/flowTransectionReportSum/flowTransectionReportSum"
    reportTitle="Flow Transaction Summary"
  />
);

export default FlowTransactionReportSum;
